var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_26488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99999 0H5.24998C6.90683 0 8.24997 1.34314 8.24997 2.99999V5.24998C8.24997 6.90683 6.90683 8.24997 5.24998 8.24997H2.99999C1.34314 8.25001 0 6.90686 0 5.24998V2.99999C0 1.34314 1.34314 0 2.99999 0Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0H15C16.6569 0 18 1.34314 18 2.99999V5.24998C18 6.90683 16.6569 8.24997 15 8.24997H12.75C11.0932 8.24997 9.75006 6.90683 9.75006 5.24998V2.99999C9.75003 1.34314 11.0932 0 12.75 0Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99999 9.75H5.24998C6.90683 9.75 8.24997 11.0931 8.24997 12.75V15C8.24997 16.6568 6.90683 18 5.24998 18H2.99999C1.34314 18 0 16.6569 0 15V12.75C0 11.0931 1.34314 9.75 2.99999 9.75Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.75H15C16.6569 9.75 18 11.0931 18 12.75V15C18 16.6569 16.6569 18 15 18H12.75C11.0932 18 9.75006 16.6569 9.75006 15V12.75C9.75003 11.0931 11.0932 9.75 12.75 9.75Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_26488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsFour);
export default __webpack_public_path__ + "static/media/apps_four.91ecf71256fe4712a4207c7e1d5a7f04.svg";
export { ForwardRef as ReactComponent };